import React from "react";
import { Link } from "react-router-dom";

const TermsOfUse = () => {
  return (
    <>
      <style>{`
        .legal-page {
          animation: fadeIn 0.6s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .legal-content {
          background: #fff;
          border-radius: 16px;
          padding: 2.5rem 2rem;
          box-shadow: 0 8px 30px rgba(0,0,0,0.04);
          margin: 2rem 0;
        }

        .legal-content h2 {
          font-size: 2rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 1.5rem;
        }

        .legal-content h3 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #0a1a3d;
          margin: 2rem 0 1rem;
          padding-bottom: 0.5rem;
          border-bottom: 2px solid #f0f0f0;
          transition: border-color 0.3s;
        }

        .legal-content h3:hover {
          border-color: #e86b24;
        }

        .legal-content p,
        .legal-content li {
          color: #444;
          line-height: 1.8;
          font-size: 1rem;
          margin-bottom: 1rem;
        }

        .legal-content ul {
          padding-left: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .legal-content a {
          color: #e86b24;
          text-decoration: none;
          transition: color 0.2s;
        }

        .legal-content a:hover {
          color: #d2551a;
          text-decoration: underline;
        }

        .legal-footer-note {
          text-align: center;
          margin-top: 2rem;
          font-size: 0.9rem;
          color: #888;
        }

        @media (max-width: 576px) {
          .legal-content {
            padding: 1.5rem 1.2rem;
          }
        }
      `}</style>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Terms of Use</h1>
            <ul className="breadcumb-menu">
              <li><Link to="/">Home</Link></li>
              <li>Terms of Use</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container legal-page">
        <div className="legal-content">
          <h2>Agreement to Terms</h2>
          <p>
            By accessing or using the Sagama Homes website, you agree to be
            bound by these Terms of Use. If you do not agree, please discontinue
            use of our site.
          </p>

          <h3>Use of the Website</h3>
          <ul>
            <li>The content on this site is for informational purposes only and does not constitute professional advice.</li>
            <li>You may not reproduce, distribute, or exploit any content without our prior written consent.</li>
            <li>You agree not to use the site for any unlawful purpose or in a way that could damage, disable, or impair the website.</li>
          </ul>

          <h3>Property Listings & Information</h3>
          <p>
            All property details, including prices, availability, and
            specifications, are subject to change without notice. Sagama Homes
            makes no warranties regarding the accuracy or completeness of the
            information provided. We recommend verifying any details directly
            with our sales team before making any decisions.
          </p>

          <h3>Intellectual Property</h3>
          <p>
            All text, images, logos, and designs on this website are the
            intellectual property of Sagama Homes and are protected by
            applicable copyright and trademark laws.
          </p>

          <h3>Limitation of Liability</h3>
          <p>
            Sagama Homes shall not be held liable for any direct, indirect, or
            consequential damages resulting from the use or inability to use
            this website, including but not limited to errors, omissions, or
            interruptions.
          </p>

          <h3>External Links</h3>
          <p>
            Our website may contain links to third‑party websites. We are not
            responsible for the content or privacy practices of those sites.
          </p>

          <h3>Changes to Terms</h3>
          <p>
            We reserve the right to modify these Terms of Use at any time.
            Continued use of the site after changes constitutes acceptance of
            the new terms.
          </p>

          <div className="legal-footer-note">
            Last updated: May 2026
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;